export var Actions;
(function (Actions) {
    Actions["GET_ANSWER_TYPE"] = "getAnswerTypeAction";
})(Actions || (Actions = {}));
export var AnswerType;
(function (AnswerType) {
    AnswerType["FrApl02"] = "FR.APL.02";
    AnswerType["FrIa01"] = "FR.IA.01";
    AnswerType["FrIa02"] = "FR.IA.02";
    AnswerType["FrIa03"] = "FR.IA.03";
    AnswerType["FrIa07"] = "FR.IA.07";
    AnswerType["FrIa08"] = "FR.IA.08";
    AnswerType["FrIa09"] = "FR.IA.09";
    AnswerType["FrIa10"] = "FR.IA.10";
})(AnswerType || (AnswerType = {}));
